import type { UDAConfig } from '@funkit/connect-core'

import { useDynamicConfig } from '../../statsig/useDynamicConfig'
import { useMemo } from 'react'

/**
 * Thin RN reimplementation of `@funkit/connect`'s `useUDAParams`. Resolves the
 * Universal Deposit Address config for a dynamic-routing id from the
 * `uda_params` Statsig dynamic config. Unlike web, the routing id is passed in
 * (web reads it from the checkout context, which RN doesn't have).
 */
export function useUDAParams(dynamicRoutingId?: string): UDAConfig | undefined {
  const udaParams = useDynamicConfig('uda_params')
  return useMemo(
    () =>
      udaParams.find((param) => param.dynamicRoutingId === dynamicRoutingId)
        ?.params,
    [udaParams, dynamicRoutingId],
  )
}
